import { setSiteDetailsData, resetSiteDetailsData } from '../../../redux/siteDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import React, { useCallback, useEffect, useState } from 'react';
import SiteDetailsContent from './siteDetailsContent';
import { Box, CircularProgress } from '@mui/material';
import SiteDetailsHeader from './siteDetailsHeader';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const SiteDetails = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const fetchSiteDetails = useCallback(async () => {
    try {
      const { data, status } = await axios.get(`site/${id}`);
      if ((status === 200 || status === 201) && data) {
        dispatch(setSiteDetailsData(data));
        setLoading(false);
      } else {
        setLoading(false);
        console.warn('Unexpected response status or empty data:', status, data);
      }
    } catch (error) {
      setLoading(false);
      console.error('Erreur lors de la récupération des informations de site :', error);
      CustomErrorLogger(error, 'Erreur dans fetchSiteDetails');
    }
  }, [id, dispatch]);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch site details on mount and cleanup on unmount
  useEffect(() => {
    fetchSiteDetails();
    return () => {
      dispatch(resetSiteDetailsData());
    };
  }, [fetchSiteDetails, dispatch]);

  return (
    <Box>
      {loading ?
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress
            sx={{
              '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
            }}
          />
        </Box>
        :
        <Box>
          <SiteDetailsHeader />
          <SuccessfullModifyDialog />
          <SiteDetailsContent />
        </Box>
      }
    </Box>
  );
}

export default SiteDetails;